module.exports = __webpack_public_path__ + "static/media/DONT SHOOT FILMS.fb199979.jpg";